import { DefaultApi } from "../../../api";
import { getCatchError } from "../../../getCatchError";
import { urls } from "../../../urls";

const setUpdatePassword = (params) => {
    return async (dispatch, getState) => {
        try {
            await DefaultApi({
                params,
                method: 'post',
                url: urls.POST_CHANGE_PASSWORD
            });

        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setUpdatePassword as SetUpdatePassword
}